var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-browser-icon"},[(_vm.type === `avatar`)?_c('b-avatar',{staticClass:"image",class:_vm.className,attrs:{"src":_vm.getImageSrc}}):(_vm.type === `image`)?_c('b-img',{staticClass:"image",class:_vm.className,attrs:{"src":_vm.getImageSrc}}):_c('div',{staticClass:"icon",class:_vm.className,style:(_vm.style)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }